import { render, staticRenderFns } from "./KnowledgePointReviewModal.vue?vue&type=template&id=8a8a8ec2&scoped=true"
import script from "./KnowledgePointReviewModal.vue?vue&type=script&lang=js"
export * from "./KnowledgePointReviewModal.vue?vue&type=script&lang=js"
import style0 from "./KnowledgePointReviewModal.vue?vue&type=style&index=0&id=8a8a8ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8a8ec2",
  null
  
)

export default component.exports